import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';

import './FadeIn.css';

// This component is built on top of `CSSTransition` from react-transition-group
// It handles all the animations in concert with React updates.
// Docs: http://reactcommunity.org/react-transition-group/css-transition

const FadeIn = ({
  children,
  appearOnMount = true,
  enter = true,
  timeout = 500,
  ...props
}) => (
  <CSSTransition
    appear={appearOnMount}
    in={enter}
    classNames="fadein"
    timeout={timeout}
    {...props}
  >
    {children}
  </CSSTransition>
);

FadeIn.defaultProps = {
  appearOnMount: true,
  enter: true,
  timeout: 500,
};

FadeIn.propTypes = {
  children: PropTypes.node.isRequired,
  appearOnMount: PropTypes.bool,
  enter: PropTypes.bool,
  timeout: PropTypes.number
};

export default FadeIn;
